import NavMenuItem from './NavMenuItem';
import { NavMenuItemProps, NavMenuItemValueProps } from './types';

export type { NavMenuItemProps, NavMenuItemValueProps };
export default NavMenuItem;
